module.exports = __webpack_public_path__ + "static/img/rrrr_47.09d3b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_47.png
// module id = 8uXZ
// module chunks = 1